import {
  makeObservable,
  observable,
  action,
  // computed
} from "mobx";

export class NavbarStore {
  isOpen: any[] = []; //for active default menu
  isTrigger: any[] = [];

  layout = "vertical";
  preLayout = "";
  layoutType = "menu-light";
  navBackColor = "navbar-default"; // navbar-default, (navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark are not available in lite version)
  navBrandColor = "brand-default"; // brand-default, (brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark are not available in lite version)
  headerBackColor = "header-default"; //header-default, (header-blue, header-red, header-purple, header-lightblue, header-dark are not available in lite version)
  headerFixedLayout: boolean = false;
  navDropdownIcon = "style1";
  navListIcon = "style1";
  navActiveListColor = "active-default";
  navListTitleColor = "title-default";
  navBackImage?: string;
  navIconColor: boolean = false;
  configBlock: boolean = false;
  navFixedLayout: boolean = true;
  navListTitleHide: boolean = false;
  //   isSideBarCollapsed1: boolean = false;
  layout6Background =
    "linear-gradient(to right, #A445B2 0%, #D41872 52%, #FF0066 100%)";
  layout6BackSize = "";
  boxLayout: any;
  isSideBarCollapsed: boolean = false;

  rootStore: any;

  constructor(rootStore: any) {
    this.rootStore = rootStore;
    makeObservable(this, {
      isOpen: observable,
      isTrigger: observable,
      layout: observable,
      preLayout: observable,
      layoutType: observable,
      navBackColor: observable,
      navBrandColor: observable,
      headerBackColor: observable,
      headerFixedLayout: observable,
      navDropdownIcon: observable,
      navListIcon: observable,
      navActiveListColor: observable,
      navListTitleColor: observable,
      navBackImage: observable,
      navIconColor: observable,
      configBlock: observable,
      navFixedLayout: observable,
      navListTitleHide: observable,
      layout6Background: observable,
      layout6BackSize: observable,
      boxLayout: observable,
      isSideBarCollapsed: observable,
      toggleMinimizeSideBar: action,
      onChangeLayout: action,
      onCollapseToggle: action,
      onToggleNavigation: action,
      onNavCollapseLeave: action,
    });
  }

  toggleMinimizeSideBar = () => {
    this.isSideBarCollapsed = !this.isSideBarCollapsed;
  };

  onChangeLayout = (layoutClass: string) => {
    this.layout = layoutClass;
  };

  onCollapseToggle = (id: string, type: string | undefined) => {
    let open = this.isOpen;
    let trigger = this.isTrigger;

    if (type === "sub") {
      const triggerIndex = trigger.indexOf(id);
      if (triggerIndex > -1) {
        open = open.filter((item) => item !== id);
        trigger = trigger.filter((item) => item !== id);
      }

      if (triggerIndex === -1) {
        open = [...open, id];
        trigger = [...trigger, id];
      }
    } else {
      open = this.isOpen;
      const triggerIndex = this.isTrigger.indexOf(id);
      trigger = triggerIndex === -1 ? [id] : [];
      open = triggerIndex === -1 ? [id] : [];
    }

    this.isOpen = open;
    this.isTrigger = trigger;
  };

  onToggleNavigation = () => {
    this.toggleMinimizeSideBar();
  };

  onNavCollapseLeave = (id, type) => {
    if (type && type === "sub") {
      let open = this.isOpen;
      let trigger = this.isTrigger;

      const triggerIndex = trigger.indexOf(id);
      if (triggerIndex > -1) {
        open = open.filter((item) => item !== id);
        trigger = trigger.filter((item) => item !== id);
      }

      this.isOpen = open;
      this.isTrigger = trigger;
    }
  };
  // dispatch({type: actionTypes.NAV_COLLAPSE_LEAVE, menu: {id: id, type: type}})
}
